import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { produce } from "immer";

import { hasFailedInstantMatch } from "../../lib/VerificationService/VerificationServiceHelpers";
import {
  VerificationService,
  CollectIdentifierViewModel,
  PersonalInfoResponse,
} from "../../lib/types/types";

import {
  handleEmailOnKeyDown,
  updateFieldValidationErrorsByFieldId,
} from "../../lib/utils/stepComponentHelpers/stepComponentHelpers";
import { FormFooterComponent as FormFooter } from "../FormFooter/FormFooterComponent";

import { EmailComponent as Email } from "../FormFields/Email/EmailComponent";
import { VerificationStepsEnum } from "../../lib/types/runtimeTypes";
import { PersonalInfoHeader } from "../FormHeader/StepHeaders/PersonalInfoHeaderComponent";
import { PersonalInfoStepSubmitButton } from "../PersonalInfoStepSubmitButton/PersonalInfoStepSubmitButton";

interface StepCollectIdentifierProps {
  verificationService: VerificationService;
}

const StepCollectIdentifier = ({ verificationService }: StepCollectIdentifierProps) => {
  const viewModel = verificationService.viewModel as CollectIdentifierViewModel;
  const { fieldValidationErrors } = verificationService;
  const verificationResponse = verificationService.verificationResponse as PersonalInfoResponse;
  const failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  const updateCollectIdentifierViewmodel = (key: keyof CollectIdentifierViewModel, value: any) => {
    const nextState: CollectIdentifierViewModel = produce(
      viewModel,
      (draft: CollectIdentifierViewModel) => {
        (draft[key] as any) = value;
      },
    );
    verificationService.updateViewModel(nextState);
  };

  return (
    <div
      id="sid-step-collect-transaction-id"
      className="sid-step-collect-transaction-id-container sid-l-container"
    >
      <div role="main">
        <PersonalInfoHeader
          verificationService={verificationService}
          classNameIdentifier="step-collect-transaction-id"
        />

        <Email
          value={viewModel.email}
          isErrored={!!fieldValidationErrors.email}
          explanation={
            <FormattedHTMLMessage
              id="step.collectIdentifier.inputExplanation"
              defaultMessage="Needed to send authentication code"
            />
          }
          onChange={(newValue) => {
            updateCollectIdentifierViewmodel("email", newValue);
            updateFieldValidationErrorsByFieldId("email", newValue, verificationService);
          }}
          onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => handleEmailOnKeyDown(event)}
        />

        <PersonalInfoStepSubmitButton
          step={VerificationStepsEnum.collectIdentifier}
          verificationService={verificationService}
          viewModel={viewModel}
          failedInstantMatch={failedInstantMatch}
          buttonText={
            <FormattedHTMLMessage
              id="step.personalInfo.submitButtonText"
              defaultMessage="Verify and continue"
            />
          }
        />
      </div>
      <FormFooter verificationService={verificationService} />
    </div>
  );
};

export const StepCollectIdentifierComponent = StepCollectIdentifier;
